import { ClickAndCollect, Mail, PhoneIcon } from '@components/icons'
import Link from 'next/link'
import { StoreItem } from '../types'

interface Props extends StoreItem {
  isLocalStore?: boolean
  onSetStore?: () => void
  enableSetStore?: boolean
  idPrefix?: string
}

const StoreCardItem = ({
  enableSetStore = true,
  isLocalStore = false,
  name,
  address,
  phone,
  email,
  handle,
  clickAndCollectAvailable = true,
  distance,
  onSetStore,
  id,
  idPrefix = '',
}: Props) => {
  const _distance = distance
    ? Number.parseInt(String(distance / 1000)).toLocaleString('en-US', {
        style: 'unit',
        unit: 'kilometer',
      })
    : 0
  return (
    <div className="flex flex-col py-4">
      <div className="flex justify-between items-center">
        <h3 className="text-18 font-bold">{name}</h3>
        {_distance !== 0 && _distance}
      </div>
      <span className="pt-1 text-14">{address}</span>
      <div className="mt-2 mb-4">
        <div className="flex items-center text-14 font-medium font-body mb-2">
          <PhoneIcon className="mr-2" />
          {phone && <Link href={`tel:${phone ?? ''}`} legacyBehavior>{phone}</Link>}
        </div>
        <div className="flex items-center text-14 font-medium font-body mb-2">
          <Mail className="mr-2" />
          {email && (
            <Link href={`mailto:${email ?? ''}`} className="underline" legacyBehavior>
              {email}
            </Link>
          )}
        </div>
        {clickAndCollectAvailable && (
          <div className="flex items-center text-14 font-medium font-body mb-2">
            <ClickAndCollect className="mr-2" />
            <span>This store offers click & collect</span>
          </div>
        )}
      </div>
      <div className="flex flex-col items-center w-full text-14 ">
        {enableSetStore && (
          <div className="mb-2 w-full text-center">
            {isLocalStore ? (
              <button className="bg-brand-dark-grey w-full text-white py-2 rounded-sm hover:bg-brand-darkest-grey">
                Your store
              </button>
            ) : (
              <button
                className="w-full py-2 rounded-sm border-brand-dark-grey border hover:bg-brand-dark-grey hover:text-white transition-all delay-50"
                id={`${idPrefix}-${id}`}
                onClick={onSetStore}
              >
                Set as store
              </button>
            )}
          </div>
        )}
        {/* <div className="mt-2 w-full text-center">
          <Link
            href={`/stores/${handle}`}
            title={name}
            className="text-center cursor-pointer"
            target="_blank"
            passHref
          >
            View store details ›
          </Link>
        </div> */}
      </div>
    </div>
  );
}

export default StoreCardItem
